export default {
  sections: {
    settings: 'Paramètres',
  },
  status_switch: {
    label: 'Programme de fidélité',
    on: 'Activé',
    off: 'Désactivé',
    description: "Les clients gagnent du cashback sur chaque commande et peuvent l'échanger lors du paiement.",
    description_missing: 'Enregistrez les paramètres ci-dessous pour démarrer votre programme de fidélité.',
  },
  alerts: {
    off: 'Votre programme de fidélité est désactivé. Les clients ne gagnent pas de cashback sur les nouvelles commandes, ne peuvent pas échanger leurs points et ne voient pas le programme dans votre boutique. Les points déjà collectés sont conservés et expirent normalement.',
    expired: 'Votre programme de fidélité a pris fin. Activez-le pour le relancer sans date de fin.',
  },
  form: {
    title: {
      label: 'Titre',
    },
    percentage: {
      label: 'Pourcentage de cashback',
      validation: {
        required: 'Le pourcentage de cashback est obligatoire',
        min: 'La valeur minimale du pourcentage de cashback est de {{value}} %',
        max: 'La valeur maximale du pourcentage de cashback est de {{value}} %',
      },
    },
    point_lifetime: {
      label: 'Combien de jours souhaitez-vous accorder à vos clients pour utiliser les points ?',
      validation: {
        min: "Minimum {{value}} jours pour l'expiration des points",
      },
    },
    min_spending_limit: {
      label: 'Limite de dépense minimale pour le cashback',
      validation: {
        required: 'La limite de dépense minimale est obligatoire',
        gt_zero: 'La limite de dépense minimale doit être supérieure à 0',
        lt_max_spending_limit: 'La limite de dépense minimale doit être inférieure à la limite maximale',
      },
    },
    max_spending_limit: {
      label: 'Limite de dépense maximale pour le cashback',
      validation: {
        required: 'La limite de dépense maximale est obligatoire',
        gt_min_spending_limit: 'La limite de dépense maximale doit être supérieure à la limite minimale',
      },
    },
    has_welcome_bonus: {
      label: 'Bonus de bienvenue',
      description: "Offrez à vos nouveaux clients un bonus de cashback à l'inscription",
    },
    welcome_bonus: {
      label: 'Valeur du bonus de bienvenue',
    },
    has_end_date: {
      label: 'Durée',
      options: {
        false: 'Illimitée',
        true: 'Avec une date de fin précise',
      },
    },
    end_date: {
      label: 'Date de fin',
    },
    has_mobile_app_signup_bonus: {
      label: "Bonus d'inscription à l'application mobile",
      description: "Récompensez les utilisateurs qui se connectent pour la première fois via l'application mobile",
    },
    mobile_app_signup_bonus: {
      label: 'Montant du bonus',
    },
  },
  tags: {
    inactive: 'Inactif',
    active: 'Actif',
    expired: 'Expiré',
  },
  buttons: {
    save: 'Enregistrer',
  },
  toasts: {
    changes_got_saved: 'Les modifications ont été enregistrées',
    failed_to_save_changes: "Échec de l'enregistrement des modifications",
    turned_on: 'Programme de fidélité activé',
    turned_off: 'Programme de fidélité désactivé',
  },
};
